import React from "react"
import tw, { styled } from "twin.macro"
import Select, { components } from "react-select"

import { Icon } from "../Icon/Icon"
import { Body } from "../Styled/Text"

const Label = styled.label`
  ${tw`block relative`}
  ${({ disabled }) => (disabled ? tw`cursor-not-allowed` : tw`cursor-pointer`)}
  ${({ spacing }) => {
    if (spacing === "small") return tw`mb-1-2`
  }}
`

const HiddenInput = tw.input`
  absolute top-0 left-0 h-0-1 w-0-1 opacity-0
`

const DropdownIndicator = props => {
  const {
    selectProps: { menuIsOpen },
  } = props
  return (
    <components.DropdownIndicator {...props}>
      <Icon name={menuIsOpen ? `arrowDropdownActive` : `arrowDropdown`} />
    </components.DropdownIndicator>
  )
}

const Styles = {
  form: {
    control: (styles, state) => {
      const borderColour = state.selectProps.defaultColour === "yellow" ? `#FFAB00` : `#9A9A9A`
      return {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        border: `1px solid ${borderColour}`,
        borderBottom: state.selectProps.menuIsOpen ? 0 : `1px solid ${borderColour}`,
        borderRadius: 0,
        transition: "all 0.2s ease",
        padding: "0 0 0 0.75rem",
      }
    },
    option: () => ({
      font: "inherit",
      fontSize: "12px",
      lineHeight: "15px",
      borderBottom: "1px solid #9A9A9A",
      padding: "0.5rem 0",
      margin: "0 0.75rem",
      paddingLeft: "1px",
      ":last-of-type": {
        borderBottom: 0,
      },
      ":first-of-type": {
        borderTop: "1px solid #9A9A9A",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (styles, state) => ({
      ...styles,
      padding: 0,
      color: state.selectProps.defaultColour === "yellow" ? `#FFAB00` : `#9A9A9A`,
    }),
    indicatorsContainer: (styles, state) => {
      const borderColour = state.selectProps.defaultColour === "yellow" ? `#FFAB00` : `#9A9A9A`
      return {
        borderLeft: state.selectProps.menuIsOpen ? "0" : `1px solid ${borderColour}`,
      }
    },
    valueContainer: () => ({
      font: "inherit",
      WebkitOverflowScrolling: "touch",
      alignItems: "center",
      display: "flex",
      flex: 1,
      flexWrap: "wrap",
      overflow: "hidden",
      padding: 0,
      position: "relative",
      fontSize: "12px",
      lineHeight: "15px",
    }),
    menu: (styles, state) => {
      const borderColour = state.selectProps.defaultColour === "yellow" ? `#FFAB00` : `#9A9A9A`
      return {
        font: "inherit",
        backgroundColor: "#fff",
        boxSizing: "border-box",
        marginTop: "-1px",
        label: "menu",
        position: "absolute",
        top: "100%",
        width: "100%",
        zIndex: 20,
        border: `1px solid ${borderColour}`,
        borderTop: 0,
      }
    },
    menuList: styles => ({
      ...styles,
      margin: 0,
    }),
  },
}

export const Dropdown = ({
  name,
  options,
  value,
  handleChange,
  placeholder = "",
  className = "",
  layout = "form",
  required = false,
  colour = "",
  label,
  spacing = "",
  disabled = false,
  defaultValue = null,
}) => (
  <Label htmlFor={label} className={className} disabled={disabled} spacing={spacing}>
    <Body spacing={spacing}>{required ? `${label}*` : label}</Body>
    <Select
      components={{ DropdownIndicator }}
      styles={Styles[layout]}
      name={name}
      placeholder={placeholder}
      options={options}
      value={options.find(option => option.value === value)}
      onChange={option => handleChange({ target: { value: option.value, name, type: "select" } })}
      defaultColour={colour}
      isDisabled={disabled}
      defaultValue={defaultValue}
    />
    {required && <HiddenInput tabIndex={-1} autoComplete="off" value={value} required />}
  </Label>
)
